import React from 'react';
import Navbar from '../components/landing/Navbar';
import HeroSectionV2 from '../components/v2/HeroSectionV2';
import ProblemSectionV2 from '../components/v2/ProblemSectionV2';
import SolutionSectionV2 from '../components/v2/SolutionSectionV2';
import AboutSection from '../components/landing/AboutSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import PricingSection from '../components/landing/PricingSection';
import TeamSection from '../components/landing/TeamSection';
import FAQSection from '../components/landing/FAQSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';
import SolutionSection from '../components/landing/SolutionSection';
import ContactSection from '../components/landing/ContactSection';


export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <HeroSectionV2 />
      <ProblemSectionV2 />
      <SolutionSectionV2 />
      <AboutSection />
      <SolutionSection />
      <HowItWorksSection />
      <PricingSection />
      <TeamSection />
      <ContactSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}